module.exports = __webpack_public_path__ + "img/dostal.971e1352.jpg";